import { render } from "./PredictNow.vue?vue&type=template&id=3a20c031&scoped=true"
import script from "./PredictNow.vue?vue&type=script&lang=js"
export * from "./PredictNow.vue?vue&type=script&lang=js"

import "./PredictNow.vue?vue&type=style&index=0&id=3a20c031&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a20c031"]])

export default __exports__